import * as React from "react";
import styles from "./Header.module.scss";
import { Link, useHistory } from "react-router-dom";
import faultIcon from "../../assets/fault.svg";
import koneLogoWhite from "../../assets/kone-logo-white.svg";
import backArrow from "../../assets/back-arrow.svg";
import UserMenu from "../UserMenu/UserMenu";
import { useLocation } from "react-router-dom";
import { major, minor, sprint, build } from "../../utils/versionNumber.json";

const versionHeader = major + "." + minor + "." + sprint + "." + build;

export type HeaderProps = {
  userName: string;
  userTitle?: string;
  setLanguageSelectionOpen: (value: boolean) => void;
  setMobileUserMenuOpen: (value: boolean) => void;
  koneLogoPressed: () => void;
  setFeedbackOpen: (value: boolean) => void;
};

const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const history = useHistory();
  const versionDataLink = (value: string) => {
    if (value.includes("?") || value.includes("&")) {
      return value + "&versionNotice=true";
    } else {
      return value + "?versionNotice=true";
    }
  };

  const HeaderIcon = (value: string) => {
    if (value.includes("code")) {
      return (
        <div className={styles.HeaderBackArrowDiv}>
          <Link to="#" onClick={props.koneLogoPressed}>
            <img alt="Kone" src={backArrow}></img>
          </Link>
        </div>
      );
    } else {
      return (
        <div className={styles.HeaderKoneDiv}>
          <Link to="#" onClick={props.koneLogoPressed}>
            <img alt="Kone" src={koneLogoWhite}></img>
          </Link>
        </div>
      );
    }
  };

  const redirectHome = () => {
    history.push("/");
  };
  return (
    <div className={styles.Header}>
      <div className={styles.OnlyInMobile}>{HeaderIcon(useLocation().search)}</div>
      <div className={styles.OnlyInDesktop}>
        <div className={styles.HeaderIconDiv}>
          <Link to="/">
            <img alt="Info" src={faultIcon} />
          </Link>
        </div>
      </div>
      <div className={styles.HeaderAppNameAndVersionDiv}>
        <h1>Fault Viewer</h1>
        <p>
          <Link to={versionDataLink(useLocation().search)}>{versionHeader}</Link>
        </p>
      </div>
      <div className={styles.HeaderUserMenu}>
        <React.Suspense fallback={"Loading localizations"}>
          <UserMenu
            userName={props.userName}
            userTitle={props.userTitle}
            setLanguageSelectionOpen={props.setLanguageSelectionOpen}
            setMobileUserMenuOpen={props.setMobileUserMenuOpen}
            setFeedbackOpen={props.setFeedbackOpen}
          />
        </React.Suspense>
      </div>
      <div className={styles.OnlyInDesktop}>
        <div className={styles.HeaderKoneDiv} onClick={() => redirectHome()}>
          <img alt="Kone" src={koneLogoWhite} />
        </div>
      </div>
    </div>
  );
};

export default Header;
